import React from "react";
import MemberProgramStyle from "./MemberProgram.style";
import { withStyles } from "@material-ui/styles";
import PinkIcon from "Assets/start/Pink-icon.svg";
import GreenIcon from "Assets/start/Green-icon.svg";
import BlueIcon from "Assets/start/Blue-icon.svg";
import Hidden from "@material-ui/core/Hidden";
import T from "Translate";
import store from "Store";

const featureList = [
    { icon: GreenIcon, title: <T>ump_p1</T>, detail: <T>ump_d1</T>, key: "Free & Easy to Join" },
    { icon: BlueIcon, title: <T>ump_p2</T>, detail: <T>ump_d2</T>, key: "Exclusive Member Pricing" },
    { icon: PinkIcon, title: <T>ump_p3</T>, detail: <T>ump_d3</T>, key: "Earn Rewards" }
];

const filterFeatureList = () => {
    switch (store.getState().locale.country) {
        case "TH":
            return featureList.slice().filter(list => list.key !== "Earn Rewards");

        default:
            return featureList;
    }
};

const MemberProgram = props => {
    const { classes } = props;

    return (
        <div className={classes.root} data-testid="member_program_section">
            <Hidden smDown>
                <div className={classes.mpHeader} data-testid="member_program_title">
                    <T>ump_header</T>
                </div>
            </Hidden>

            <div className={classes.featureListContainer}>
                {filterFeatureList().map((item, idx) => (
                    <div className={classes.featureList} key={idx} data-testid="member_program_feature">
                        <div className={classes.iconImage}>
                            <img alt="Unicity Main" src={item.icon} />
                        </div>
                        <div className={classes.article}>
                            <div data-testid="member_program_feature_title">{item.title}</div>
                            <p data-testid="member_program_feature_details">{item.detail}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default withStyles(MemberProgramStyle)(MemberProgram);



// WEBPACK FOOTER //
// ./src/components/StartContainer/MemberProgram.js